// eslint-disable-next-line @typescript-eslint/no-require-imports
const { evalBooleanEnvVarIsTrue, evalStringOneOf } = require('./utils/envVarUtils');

// static environment variables, see also config/types/environment.d.ts
const analyze = process.env.ANALYZE;
const feedsBaseURL = process.env.FEEDS_BASE_URL;
const contentBasePath = process.env.CONTENT_BASE_PATH;
// Note @neoxu, 2025-10-20: Where the assets are served from. By default same with contentBasePath.
// If you want to serve assets from a different path, set this variable.
const assetsBasePath = process.env.ASSETS_BASE_PATH;
const creatorClientId = process.env.CREATOR_CLIENT_ID;
const contentLocalDir = process.env.CONTENT_LOCAL_DIR;
const openSourceContentLocalDir = process.env.OPEN_SOURCE_CONTENT_LOCAL_DIR;
const openSourceRepo = process.env.OPEN_SOURCE_REPO;
const openSourceBranch = process.env.OPEN_SOURCE_BRANCH;
const sentryRelease = process.env.SENTRY_RELEASE;
const buildTarget = process.env.BUILD_TARGET ?? 'global';
const pullRequestNumberString = process.env.PULL_REQUEST_NUMBER;
const artifactoryAccessToken = process.env.ARTIFACTORY_ACCESS_TOKEN;
const engineDocumentationCommit = process.env.ENGINE_DOCUMENTATION_COMMIT;
const engineDocumentationSource = process.env.ENGINE_DOCUMENTATION_SOURCE;
const engineDocumentationJsonPath = process.env.ENGINE_DOCUMENTATION_JSON_PATH;
const recommendedSearchType = evalStringOneOf(
  'RECOMMENDED_SEARCH_TYPE',
  ['titles', 'scoredTitles', 'm1ReleaseVariant1', 'm1ReleaseVariant2'],
  'disabled',
);
const enableSearchAskAssistant = evalBooleanEnvVarIsTrue('ENABLE_SEARCH_ASK_ASSISTANT');
const enableCourses = evalBooleanEnvVarIsTrue('ENABLE_COURSES');
const enableTryItOut = evalBooleanEnvVarIsTrue('ENABLE_TRY_IT_OUT');
const enableOpenCloudIAV2Pages = evalBooleanEnvVarIsTrue('ENABLE_OPEN_CLOUD_IAV2_PAGES');
const enableEngineReferenceRevamp = evalBooleanEnvVarIsTrue('ENABLE_ENGINE_REFERENCE_REVAMP');

const environment = process.env.TARGET_ENV ?? 'development';

// NOTE(@christinewang, 08/09/2023): adding version prefix to JS + CSS static files
const versionPrefix = process.env.BARISTA_DEPLOYMENT_VERSION
  ? `/${process.env.BARISTA_DEPLOYMENT_VERSION}`
  : '';
const assetCDNPrefix = process.env.BARISTA_DEPLOYMENT_ASSET_CDN
  ? `https://${process.env.BARISTA_DEPLOYMENT_ASSET_CDN}`
  : '';

const baseUrl =
  process.env.BASE_URL ??
  `https://localhost.sitetest3.robloxlabs.com:${process.env.LOCALHOST_PORT ?? 3000}`;
const siteBasePath = process.env.SITE_BASE_PATH ?? '';

const staticFilesPrefix =
  process.env.NODE_ENV !== 'production' || process.env.DEPLOYMENT_ENVIRONMENT === 'preview'
    ? siteBasePath
    : `${assetCDNPrefix}${siteBasePath}${versionPrefix}`;

const assetPathPrefix = `${staticFilesPrefix}/assets`;

// NOTE (tchu, 2025-08-22):
// To access the settings object from the frontend, use process.env.settings.settingName
// e.g. process.env.settings.recommendedSearchType
// To access the settings object from the build time, use settings.settingName
const settings = {
  disableHotReload: evalBooleanEnvVarIsTrue('DISABLE_HOT_RELOAD'),
  enableHiddenContent: evalBooleanEnvVarIsTrue('ENABLE_HIDDEN_CONTENT', (setting) =>
    typeof setting !== 'undefined' ? setting === 'true' : environment !== 'production',
  ),
  enableCommunityContent: evalBooleanEnvVarIsTrue('ENABLE_COMMUNITY_CONTENT'),
  enableRunCodeInStudio: evalBooleanEnvVarIsTrue('ENABLE_RUNNABLE_CODE'),
  noindexPageSlugsCSV: process.env.NO_INDEX_PAGE_SLUGS_CSV ?? '',
  enableRoasContent: evalBooleanEnvVarIsTrue('ENABLE_ROAS_CONTENT'),
  useEngineDocumentation: evalBooleanEnvVarIsTrue('USE_ENGINE_DOCUMENTATION'),
  hideDevErrors: evalBooleanEnvVarIsTrue('HIDE_DEV_ERRORS'),
  enableEngineApiMemberPages: (() => {
    const memberPagesSting = process.env.ENABLE_ENGINE_API_MEMBER_PAGES;
    if (!memberPagesSting) return [];
    if (memberPagesSting === 'all') {
      return memberPagesSting;
    }
    try {
      const pages = JSON.parse(memberPagesSting);
      if (Array.isArray(pages)) {
        return pages;
      }
      console.error(
        `ENABLE_ENGINE_API_MEMBER_PAGES should be either 'all' or array in JSON: ${memberPagesSting}`,
      );
    } catch (e) {
      console.error(`Error parsing ENABLE_ENGINE_API_MEMBER_PAGES: ${e}`);
    }
    return [];
  })(),
};

// for `next dev`, process.env.NODE_ENV === 'development'
// for `next build`, process.env.NODE_ENV === 'production'
const connectsRemoteServer =
  process.env.IS_EXPORT !== 'true' &&
  (process.env.CONNECTS_REMOTE_SERVER === 'true' || process.env.NODE_ENV === 'production');

module.exports = {
  baseUrl,
  environment,
  settings,
  analyze,
  siteBasePath,
  connectsRemoteServer,
  assetPathPrefix,
  staticFilesPrefix,
  feedsBaseURL,
  contentBasePath,
  assetsBasePath,
  creatorClientId,
  contentLocalDir,
  openSourceContentLocalDir,
  openSourceRepo,
  openSourceBranch,
  sentryRelease,
  buildTarget,
  pullRequestNumberString,
  artifactoryAccessToken,
  engineDocumentationCommit,
  engineDocumentationSource,
  engineDocumentationJsonPath,
  versionPrefix,
  recommendedSearchType,
  enableSearchAskAssistant,
  enableCourses,
  enableTryItOut,
  enableOpenCloudIAV2Pages,
  enableEngineReferenceRevamp,
};
